import MobileDesign from './MobileDesign.view';

export default MobileDesign;
